<template>
  <!-- begin:: Header -->
  <div
    id="kt_header"
    ref="kt_header"
    class="header"
    v-bind:style="islanding || islogin || isregister?'position:relative !important':'position:fixed !important'"
    v-bind:class="headerClasses"
  >
    <div
      class="container d-flex align-items-center"
    >
      <!-- begin:: Header Menu -->
      <div
        class="header-menu-wrapper header-menu-wrapper-left"
        ref="kt_header_menu_wrapper"
      >
        <div
          v-if="headerMenuEnabled"
          id="kt_header_menu"
          ref="kt_header_menu"
          class="header-menu header-menu-mobile"
          v-bind:class="headerMenuClasses"
        >
        <div class="header-logo">
          <a href="/">
            <v-img :src="require('@/assets/images/logo.png')"></v-img>
          </a>
        </div>
        </div>
      </div>

      <div
        class="header-menu-wrapper header-menu-wrapper-right"
        ref="kt_header_menu_wrapper"
      >
        <div
          v-if="headerMenuEnabled"
          class="header-menu header-menu-mobile"
          v-bind:class="headerMenuClasses"
        >
        <v-img class="right-logo" height="80" :src="require('@/assets/images/for_education.png')"></v-img>
        </div>
      </div>
      <!-- end:: Header Menu -->
     
    </div>
  </div>
  <!-- end:: Header -->
</template>
<script>
import { mapGetters } from "vuex";
// import KTTopbar from "@/view/layout/header/Topbar.vue";
import KTLayoutHeader from "@/assets/js/layout/base/header.js";
import KTLayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";

export default {
  name: "KTHeader",
  components: {
    // KTTopbar
  },
  data() {
    return {
      islanding:false,
      isregister:false,
      islogin:false,
    }
  },
  mounted() {
    // Init Desktop & Mobile Headers
    KTLayoutHeader.init("kt_header", "kt_header_mobile");
    // Init Header Menu
    KTLayoutHeaderMenu.init(
      this.$refs["kt_header_menu"],
      this.$refs["kt_header_menu_wrapper"]
    );
    var pathname = new URL(location.href).pathname;

    if (pathname == '/') {
      this.islanding = true;
      this.isregister = false;
      this.islogin = true;

      if (!this.isAuthenticated) {
        this.$router.push({ name: "login" });
      }

    } else if (pathname.includes('register')) {
      this.islanding = false;
      this.isregister = true;
      this.islogin = false;
      // if (this.isAuthenticated) {
        this.$router.push({ name: "login" });
      // }
    } else if(pathname.includes('login')){
      this.islanding = false;
      this.isregister = false;
      this.islogin = true;
      if (this.isAuthenticated) {
        this.$router.push({ name: "landing" });
      }
    } else {
      this.islanding = false;
      this.isregister = false;
      this.islogin = false;
    }
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses", "isAuthenticated"]),

    /**
     * Check if the header menu is enabled
     * @returns {boolean}
     */
    headerMenuEnabled() {
      return !!this.layoutConfig("header.menu.self.display");
    },

    /**
     * Get extra classes for header based on the options
     * @returns {null|*}
     */
    headerClasses() {
      const classes = this.getClasses("header");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    },

    /**
     * Get extra classes for header menu based on the options
     * @returns {null|*}
     */
    headerMenuClasses() {
      const classes = this.getClasses("header_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  }
};
</script>
